import React from 'react';
import { motion } from 'framer-motion';

const CognitiveBehaviour = () => {
	return (
		<section className="relative h-[fit-content] sm:h-screen flex items-center overflow-hidden py-8 sm:py-12 md:py-16 lg:py-0" style={{ background: 'linear-gradient(180deg, #FFFFFF 23.08%, #D9D9D9 100%)' }}>
			{/* Top-Left Accent Arrow */}
			

			<div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-8 sm:py-12 md:py-16 lg:py-20 w-full">
            <motion.div 
							className="space-y-2 text-center lg:text-left"
							initial={{ y: 30, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, ease: "easeOut" }}
						>
							<h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl xl:text-6xl font-source font-semibold text-[#113861] leading-tight">
								Cognitive & Behavioural
							</h2>
							<h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl font-source italic text-[#113861] leading-tight">
								Assessments
							</h3>
						</motion.div>

				<div className="grid grid-cols-1 lg:grid-cols-12 gap-6 sm:gap-8 md:gap-10 lg:gap-12 items-start">
					{/* Left Side - Main Content */}
					<div className="lg:col-span-7 space-y-4 sm:space-y-6 md:space-y-8 text-center lg:text-left">
						{/* Main Title */}
						
						{/* Descriptive Paragraph */}
						<motion.p 
							className="text-sm sm:text-base md:text-lg lg:text-xl font-sans font-regular text-[#2b2b2b] leading-relaxed max-w-lg sm:max-w-xl md:max-w-2xl mx-auto lg:mx-0 mt-6 sm:mt-8 md:mt-12 lg:mt-16"
							initial={{ y: 30, opacity: 0 }}
							whileInView={{ y: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
						>
							Our psychometric assessments are designed to bring clarity to the decision-making process. From identifying behavioural tendencies to cognitive strengths, our tools offer personalised guidance that helps users navigate academic, leadership, and life choices with confidence. Every report provides clear decision-making insights based on validated frameworks, giving individuals a meaningful lens to understand themselves and their potential.
						</motion.p>
					</div>

					{/* Right Side - Heading and Tree Image */}
					<div className="lg:col-span-5 space-y-4 sm:space-y-6 md:space-y-8 text-center lg:text-left">
						{/* Right Heading */}
						<motion.h4 
								className="text-lg sm:text-xl md:text-2xl lg:text-3xl font-sans font-regular text-[#113861] leading-tight mt-6 sm:mt-8 md:mt-12 lg:mt-16"
							initial={{ x: 30, opacity: 0 }}
							whileInView={{ x: 0, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
						>
							Unlocking human potential through clarity and data driven insights
						</motion.h4>

						{/* Tree Image Container - Mobile/Tablet Layout */}
						<motion.div 
							className="lg:hidden flex justify-center mt-8 sm:mt-10 md:mt-12 w-[100%] h-[100%]"
							initial={{ scale: 0.8, opacity: 0 }}
							whileInView={{ scale: 1, opacity: 1 }}
							viewport={{ once: true, amount: 0.3 }}
							transition={{ duration: 1, ease: "easeOut" }}
						>
							<img
								src="/images/cog-image.png"
								alt="Vibrant stylized tree with colorful translucent leaves"
								className="w-64 h-64 sm:w-56 sm:h-56 md:w-[100%] md:h-[100%] object-contain"
								style={{ 
									filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.15))',
									width: '90%',
									height: '100%',
								
								objectFit: 'contain',
								
								 }}
							/>
						</motion.div>
					</div>
				</div>
			</div>

			{/* Desktop Image - Absolute Positioning (Original Layout) */}
			<motion.div 
				className="hidden lg:block absolute top-0 right-0 z-0 w-full h-full flex items-start justify-end"
				initial={{ scale: 0.8, opacity: 0 }}
				whileInView={{ scale: 1, opacity: 1 }}
				viewport={{ once: true, amount: 0.3 }}
				transition={{ duration: 1, ease: "easeOut" }}
			>
				<img
					src="/images/cog-image.png"
					alt="Vibrant stylized tree with colorful translucent leaves"
					className="w-[40%] h-full object-contain"
					style={{ 
						filter: 'drop-shadow(0 20px 40px rgba(0,0,0,0.15))',
						width: '37%',
						height: '100%',
					position: 'absolute',
					objectFit: 'contain',
					right: '0',
					top: '18%',
					 }}
				/>
			</motion.div>
		</section>
	);
};

export default CognitiveBehaviour;